import { render, staticRenderFns } from "./CpDomainList.vue?vue&type=template&id=4fa3c234&scoped=true&"
import script from "./CpDomainList.vue?vue&type=script&lang=js&"
export * from "./CpDomainList.vue?vue&type=script&lang=js&"
import style0 from "./CpDomainList.vue?vue&type=style&index=0&id=4fa3c234&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa3c234",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VDataTable,VRow,VSkeletonLoader,VTextField})
